import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage , deleteToken} from "firebase/messaging";
import api from "./api/api";
import { toast } from "react-toastify";

const firebaseConfig = {
  apiKey: "AIzaSyDpIp4FniiStg-bwfGMWfMVvKv9oi6T-Mk",
  authDomain: "bookmybeauty-salon.firebaseapp.com",
  projectId: "bookmybeauty-salon",
  storageBucket: "bookmybeauty-salon.firebasestorage.app",
  messagingSenderId: "753270597152",
  appId: "1:753270597152:web:4aa5ef3fdc1d918f853e45",
  measurementId: "G-VZSRV8V682",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Generate or retrieve device token
const generateDeviceToken = () => {
  let deviceToken = localStorage.getItem("device_token");
  if (!deviceToken) {
    deviceToken = `${Date.now()}-${Math.random()
      .toString(36)
      .substring(2, 15)}`;
    localStorage.setItem("device_token", deviceToken);
  }
  return deviceToken;
};

// Save FCM token to local storage
const saveFCMToken = (token: any) => {
  localStorage.setItem("fcm_token", token);
};

// Get FCM token from local storage
export const getSavedFCMToken = () => {
  return localStorage.getItem("fcm_token");
};

// Get device token from local storage
export const getSavedDeviceToken = () => {
  return localStorage.getItem("device_token");
};


// Function to request permission and get token
export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      const fcmToken = await getToken(messaging, {
        vapidKey:
          "BCIt37hhH2rfFXcTrlUuakkVHjhVb7Sg7IP9KpTaKbBvQ0GPYVip3pRZT-RWmGmueVS2sAzWYQdIjf2O-YV_NX0",
      });

      const deviceToken = generateDeviceToken();

      // Save tokens to local storage
      saveFCMToken(fcmToken);

      const token = localStorage.getItem("accesstoken");
      if (!token) {
        return;
      }

      // Send tokens to backend
      await api.post("/v1/admin/refresh/adminfcmtoken", {
        fcmToken,
        deviceToken,
      });

      return fcmToken;
    } else {
      console.warn("Notification permission denied");
    }
  } catch (error) {
    console.error("Error getting notification permission:", error);
  }
};

export { messaging };
